/* eslint-disable max-len */
import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';

/**
 *
 * @param {Object} param0
 * @param {import('graphql').DocumentNode | import('@apollo/client').TypedDocumentNode<any, import('@apollo/client').OperationVariables>} param0.query
 * @param {(data: T, setIsSuccess: Function) => void} param0.onData
 * @param {Function} param0.onError
 * @returns {[import('@apollo/client').LazyQueryExecFunction<any,import('@apollo/client').OperationVariables>, boolean, any]}
 */
const useCustomQuery = ({ query, onData, onError }) => {
  const [isSuccess, setIsSuccess] = useState(null);
  const [getData, {
    error, data, loading,
  }] = useLazyQuery(query, {
    // fetchPolicy: 'network-only',
    nextFetchPolicy: 'no-cache',
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });
  const { push } = useHistory();

  useEffect(() => {
    if (loading && isSuccess) setIsSuccess(false);
  }, [loading]);

  useEffect(() => {
    if (data) {
      onData?.(data, setIsSuccess);
    }
    if (error) {
      if (
        error?.message?.toLowerCase?.()
        === 'sorry you have no access to this resource.'
      ) {
        push('/not-allowed');
      }
      onError?.(error, data);
    }
  }, [data, error]);

  return [getData, loading, data];
};

export default useCustomQuery;
